<div class="header-bar">
  <h1>Payment Details</h1>
</div>
<div class="content-container">
  <div class="card card-w-title" style="position: relative">
    <h2 class="sub-header-bar">Bank Account Details</h2>
    <form [formGroup]="bankForm" (ngSubmit)="saveForm(bankForm.value)" autocomplete="off">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-g-12">
          <div class="ui-g-2 ui-sm-5"><label for="name">Name</label></div>
          <div class="ui-g-4 ui-sm-7">
            <input
              pInputText
              id="name"
              formControlName="name"
              maxlength="127"
              class="form-component"
              [readonly]="isImpersonating"
            />
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-2 ui-sm-5"><label for="accountNumber">Account Number</label></div>
          <div class="ui-g-4 ui-sm-7">
            <input
              pInputText
              id="accountNumber"
              formControlName="accountNumber"
              maxlength="8"
              trim
              class="form-component"
              [readonly]="isImpersonating"
            />
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-2 ui-sm-5"><label for="sortCode">Sort Code</label></div>
          <div class="ui-g-4 ui-sm-7">
            <input
              pInputText
              id="sortCode"
              formControlName="sortCode"
              maxlength="8"
              class="form-component"
              placeholder="00-00-00"
              [readonly]="isImpersonating"
            />
          </div>
        </div>
      </div>

      <h2>Self-Billing Agreement</h2>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-g-12">
          <div class="ui-grid-col-2 ui-sm-5"><label>Is Agreed</label></div>
          <div class="ui-grid-col-4 ui-sm-7">
            {{ sbAgreement && sbAgreement.agreed ? 'Yes' : 'No' }}
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-2 ui-sm-5"><label>Commited On</label></div>
          <div class="ui-grid-col-4 ui-sm-7">
            {{ sbAgreement ? (sbAgreement.commitedOn | datex : 'DD MMM YYYY') : '' }}
          </div>
        </div>
      </div>

      <div class="ui-grid-row">
        <button
          type="submit"
          pButton
          icon="fa ui-icon-check"
          label="Save"
          class="ui-button green-btn btn-to-right"
          [disabled]="!bankForm.valid || isImpersonating"
          [pTooltip]="
            isImpersonating
              ? 'Bank account details cannot be edited while impersonating a supplier'
              : null
          "
        ></button>
      </div>
    </form>

    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</div>
